var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43621 1H4.23069V3H2.5C2.22386 3 2 3.22386 2 3.5V4.5C2 4.77614 2.22386 5 2.5 5H4.23069V15H2.43586C1.64614 15 1 14.3 1 13.4445L1.00035 2.55553C1.00035 1.69999 1.64649 1 2.43621 1ZM5.30758 5V15H10.6921V13H8.5C8.22386 13 8 12.7761 8 12.5V11.5C8 11.2239 8.22386 11 8.5 11H10.6921V9H6.5C6.22386 9 6 8.77614 6 8.5V7.5C6 7.22386 6.22386 7 6.5 7H10.6921V1H5.30758V3H8.5C8.77614 3 9 3.22386 9 3.5V4.5C9 4.77614 8.77614 5 8.5 5H5.30758ZM11.769 13H13.5C13.7761 13 14 12.7761 14 12.5V11.5C14 11.2239 13.7761 11 13.5 11H11.769V9H12.5C12.7761 9 13 8.77614 13 8.5V7.5C13 7.22386 12.7761 7 12.5 7H11.769V1H13.5641C14.3539 1 15 1.69999 15 2.55554L14.9996 13.4445C14.9996 14.3 14.3535 15 13.5638 15H11.769V13Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline);
export default __webpack_public_path__ + "static/media/icon--timeline.8238472503a5db1a72750df13c9e4f1f.svg";
export { ForwardRef as ReactComponent };